import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from '../../api/instance';
import { DeviceType } from './devicesTypes.types';

const devicesApiPath = '/devices/types';

export const getDevices = async (): Promise<AxiosResponse<DeviceType[] & ApiError>> => {
  return instance.get<DeviceType[]>(devicesApiPath).catch(e => e.response as AxiosError<ApiError> as never);
};

export const createDevice = async (data: { name: string }): Promise<AxiosResponse<DeviceType & ApiError>> => {
  return instance.post<DeviceType>(devicesApiPath, data).catch(e => e.response as AxiosError<ApiError> as never);
};

const deviceApiPath = (name: string) => `/devices/types/${name}`;

export const getDevice = async ({
  deviceTypeName,
}: {
  deviceTypeName: string;
}): Promise<AxiosResponse<DeviceType & ApiError>> => {
  return instance
    .get<DeviceType>(deviceApiPath(deviceTypeName))
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const updateDevice = async ({
  deviceTypeName,
  data,
}: {
  deviceTypeName: string;
  data: DeviceType;
}): Promise<AxiosResponse<DeviceType & ApiError>> => {
  return instance
    .post<DeviceType>(deviceApiPath(deviceTypeName), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const deleteDevice = async ({
  deviceTypeName,
}: {
  deviceTypeName: string;
}): Promise<AxiosResponse<DeviceType & ApiError>> => {
  return instance
    .delete<DeviceType>(deviceApiPath(deviceTypeName))
    .catch(e => e.response as AxiosError<ApiError> as never);
};
